<!-- HIDE IF NO ADDITIONAL ATTRIBUTES TO DISPLAY -->
@if (!!donorKeywords?.length || !!levers?.length || !!(attributes | keyvalue)?.length ) {
  <div  class="view-section" id="attributes">
    <h3 class="view-section-header">Additional information</h3>
    <div class="details">
      <!-- DONOR KEYWORDS -->
      @if (donorKeywords.length > 0) {
        <div class="row">
          <div class="col-md-12" >
            <h4 class="text-diesel">Donor Keywords</h4>
            <div>
              <app-attribute #parent [isDonor]="true" [keywords]="donorKeywords">
              </app-attribute>
            </div>
          </div>
        </div>
      }
      <!-- Levers -->
      @if (!isStrategy && !isProgramManagement && !isWholeSystem && !!levers?.length) {
        <div class="row mt-2">
          <div class="col-md-12" >
            <h4 class="text-success">Project Levers</h4>
            <div>
              <app-attribute #parent [keywords]="levers">
              </app-attribute>
            </div>
          </div>
        </div>
      }
      <!-- Instruments -->
      @if (!isStrategy && !isProgramManagement && !!(attributes | keyvalue)?.length) {
        <div class="row mt-2">
          <div class="col-md-12">
            <h4 class="text-success mb-0">Science-based Instruments</h4>
            @for (item of sortInstruments(attributes | keyvalue); track item) {
              <div class="mt-0 mb-0">
                <h5 class="text-indigo mb-0">{{item.key}}</h5>
                @if (Array.isArray(item.value)) {
                  <app-attribute #parent [title]="item.key" [keywords]="item.value">
                  </app-attribute>
                }
                @if (!Array.isArray(item.value)) {
                  <div>
                    @for (obj of item.value | keyvalue; track obj) {
                      <div>
                        <h6 class="text-success mb-0">{{obj.key}}</h6>
                        <app-attribute #parent [title]="obj.key" [keywords]="obj.value">
                        </app-attribute>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
